import React from "react";
import { Grid, Skeleton } from "@mui/material";

const BackCoursesPicesDrawerSkeleton = () => {
  return (
    <Grid
      container
      rowSpacing={3}
      spacing={3}
      paddingTop={6}
      paddingLeft={4}
      paddingRight={4}
      paddingBottom={6}
      sx={{ backgroundColor: "white" }}
    >
      <Grid item xs={12}>
        <Skeleton variant="rectangular" height={60} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rectangular" height={60} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rectangular" height={60} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rectangular" height={60} />
      </Grid>
      <Grid item xs={6}>
        <Skeleton variant="rectangular" height={60} />
      </Grid>
      <Grid item xs={6}>
        <Skeleton variant="rectangular" height={60} />
      </Grid>
    </Grid>
  );
};

export default BackCoursesPicesDrawerSkeleton;
